// NOTE: these values must match the values in the C++ daemon - they are used for serialization of the key-value pairs
export var SettingEncryption;
(function (SettingEncryption) {
    SettingEncryption[SettingEncryption["CLIENT"] = 1] = "CLIENT";
    SettingEncryption[SettingEncryption["CLIENT_AND_SERVER"] = 2] = "CLIENT_AND_SERVER";
    SettingEncryption[SettingEncryption["SERVER"] = 3] = "SERVER";
    SettingEncryption[SettingEncryption["BOOTSTRAP"] = 4] = "BOOTSTRAP";
    SettingEncryption[SettingEncryption["SERVER_ENCRYPTED"] = 5] = "SERVER_ENCRYPTED";
})(SettingEncryption || (SettingEncryption = {}));
export var InternalSettingType;
(function (InternalSettingType) {
    InternalSettingType[InternalSettingType["UINT32"] = 3] = "UINT32";
    InternalSettingType[InternalSettingType["UINT64"] = 4] = "UINT64";
    InternalSettingType[InternalSettingType["STRING"] = 1] = "STRING";
    InternalSettingType[InternalSettingType["MULTI_STRING"] = 7] = "MULTI_STRING";
})(InternalSettingType || (InternalSettingType = {}));
